// Liste des rôles d'utilisateurs
export const userRoles = {
  NOTACCESS: 0,
  ADMIN: 1,
  LEVEL2: 2,
  DEV: 3
  };